// getIsHoverCapableDevice.js
'use strict';
import { getIsInBrowserMainThread } from '../resource/getJsEnvironment.js';

const HOVER_CAPABLE_QUERY = '(hover: hover) and (pointer: fine)';

/**
 * True when the device has a real hover-capable pointer (desktop mouse / pen).
 * Used to split preview rendering: desktop overlays inside the gift card;
 * touch devices use the `GiftPreviewPanel` above the SheetHeader.
 * @returns {boolean}
 * @example
 * if (getIsHoverCapableDevice()) renderInlineOverlay();
 */
const getIsHoverCapableDevice = () => {
  if (!getIsInBrowserMainThread()) return false;
  if (typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(HOVER_CAPABLE_QUERY).matches;
};

export default getIsHoverCapableDevice;
